import { Component } from '@angular/core';
import { SPINNER } from 'ngx-ui-loader';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'cafeteria';
  spinnerType = SPINNER.circle;
  showLoader = false;

  ngAfterViewInit() {
    setTimeout(() => this.showLoader = true, 0);
  }
}
